import PropTypes from 'prop-types';
import React from 'react';

const Close = ({ size, fill, ...props }) => (<svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={fill}
    {...props}
>
    <polygon
        points="19.3 2.5 17.5 0.7 10 8.1 2.5 0.7 0.7 2.5 8.1 10 0.7 17.5 2.5 19.3 10 11.9 17.5 19.3 19.3 17.5 11.9 10 " // eslint-disable-line max-len
    />
</svg>);

Close.propTypes = {
    size: PropTypes.number,
    fill: PropTypes.string,
};

Close.defaultProps = {
    size: 20,
    fill: '#5B5B5B',
};

export default Close;



// WEBPACK FOOTER //
// ./src/client/Components/Icons/Close.js